import React from "react";

import type { CompanyResearchAvailableAction, CompanyResearchIntentType } from "../lib/companyResearch";

const ACTION_DESCRIPTIONS: Record<CompanyResearchIntentType, string> = {
  learn_more: "公開情報をさらに深掘りし、詳細レポートを作成します。",
  sales: "営業提案の切り口や初回ヒアリング項目を整理します。",
  partnership: "パートナー候補として接点や協業テーマを整理します。",
  risk_check: "提案前の懸念点や確認事項を整理します。",
};

type CompanyResearchActionCardsProps = {
  actions: CompanyResearchAvailableAction[];
  loadingAction?: CompanyResearchIntentType | null;
  runningIntentTypes?: CompanyResearchIntentType[];
  lockedIntentTypes?: CompanyResearchIntentType[];
  disabled?: boolean;
  onCreateJob: (intentType: CompanyResearchIntentType) => void;
};

export function CompanyResearchActionCards({
  actions,
  loadingAction = null,
  runningIntentTypes = [],
  lockedIntentTypes = [],
  disabled = false,
  onCreateJob,
}: CompanyResearchActionCardsProps) {
  return (
    <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {actions.map((action) => {
        const isStarting = loadingAction === action.action_type;
        const isRunning = runningIntentTypes.includes(action.action_type);
        const isLocked = lockedIntentTypes.includes(action.action_type);
        const isUnavailable = action.enabled === false || action.status === "coming_soon" || action.status === "disabled";
        const isDisabled = disabled || loadingAction !== null || isRunning || isLocked || isUnavailable;
        const buttonLabel = isStarting
          ? "開始中..."
          : isRunning
            ? "実行中"
            : isLocked
              ? "実行済み"
              : isUnavailable
                ? "準備中"
                : action.label;

        return (
          <article
            key={action.action_type}
            className="flex min-h-[156px] flex-col justify-between rounded-2xl border border-[#EADBC8] bg-white p-4 shadow-sm"
          >
            <div>
              <h3 className="text-sm font-black leading-6 text-[#5D4D46]">{action.label}</h3>
              <p className="mt-2 text-xs font-bold leading-5 text-[#6B5851]">
                {action.description || ACTION_DESCRIPTIONS[action.action_type]}
              </p>
            </div>
            <button
              type="button"
              onClick={() => onCreateJob(action.action_type)}
              disabled={isDisabled}
              className="mt-4 min-h-[42px] rounded-full bg-[#7C5A4E] px-4 py-2 text-sm font-black text-white transition hover:bg-[#5D4D46] disabled:cursor-not-allowed disabled:bg-[#CBB9AF]"
            >
              {buttonLabel}
            </button>
          </article>
        );
      })}
    </div>
  );
}
